import { ExtendedListChildComponentProps } from "@/components/core/InfiniteScrollList/VirtualizedList";
import { AvatarWithTextSkeleton } from "@/components/core/skeletons/AvatarWithTextSkeleton";

type MemberListCardSkeletonProps = ExtendedListChildComponentProps;

export function MemberListCardSkeleton({
  style,
  ref,
}: MemberListCardSkeletonProps) {
  return (
    <div style={style}>
      <div className="flex items-center gap-4 p-4 rounded-lg border bg-card text-card-foreground shadow-sm" ref={ref}>
        <AvatarWithTextSkeleton
          avatarSize="md"
          textLines={[{ size: "sm", width: "lg" }]}
          align="center"
          className="flex-1 min-w-0"
        />
      </div>
    </div>
  );
}
